var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7337 22.6663V19.9997C14.7337 16.3178 11.7489 13.333 8.06706 13.333C4.38516 13.333 1.40039 16.3178 1.40039 19.9997V22.6663H14.7337ZM14.7337 22.6663H25.4004V21.333C25.4004 17.4057 22.4156 14.6663 18.7337 14.6663C16.8493 14.6663 15.1475 15.5003 13.9349 16.8411M12.0671 5.33301C12.0671 7.54214 10.2762 9.33301 8.06706 9.33301C5.85792 9.33301 4.06706 7.54214 4.06706 5.33301C4.06706 3.12387 5.85792 1.33301 8.06706 1.33301C10.2762 1.33301 12.0671 3.12387 12.0671 5.33301ZM21.4004 7.99967C21.4004 9.47248 20.2065 10.6663 18.7337 10.6663C17.2609 10.6663 16.0671 9.47248 16.0671 7.99967C16.0671 6.52691 17.2609 5.33301 18.7337 5.33301C20.2065 5.33301 21.4004 6.52691 21.4004 7.99967Z",
    fill: "#F2F2F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7337 22.6663V19.9997C14.7337 16.3178 11.7489 13.333 8.06706 13.333C4.38516 13.333 1.40039 16.3178 1.40039 19.9997V22.6663H14.7337ZM14.7337 22.6663H25.4004V21.333C25.4004 17.4057 22.4156 14.6663 18.7337 14.6663C16.8493 14.6663 15.1475 15.5003 13.9349 16.8411M12.0671 5.33301C12.0671 7.54214 10.2762 9.33301 8.06706 9.33301C5.85792 9.33301 4.06706 7.54214 4.06706 5.33301C4.06706 3.12387 5.85792 1.33301 8.06706 1.33301C10.2762 1.33301 12.0671 3.12387 12.0671 5.33301ZM21.4004 7.99967C21.4004 9.47247 20.2065 10.6663 18.7337 10.6663C17.2609 10.6663 16.0671 9.47247 16.0671 7.99967C16.0671 6.52691 17.2609 5.33301 18.7337 5.33301C20.2065 5.33301 21.4004 6.52691 21.4004 7.99967Z",
    stroke: "#F2F2F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users_icon.2566e13955bd4edea66bb65d361c13b0.svg";
export { ForwardRef as ReactComponent };